import React from "react";
import { formatNumber } from "../charts/chartTheme";

/**
 * Ranked list with a thin bar proportional to the largest value (no background track).
 * Reads better than a canvas chart on a phone: the name wraps to two lines instead of being cut off.
 * rows: [{ label, value, meta }], meta is smaller text to the right of the bar (e.g. "765 kom").
 */
export default function RankedBars({ rows, unit = "RSD" }) {
  const max = Math.max(...rows.map((r) => Number(r.value) || 0), 0) || 1;

  return (
    <ol className="flex flex-col gap-3">
      {rows.map((r, i) => {
        const pct = Math.max(2, ((Number(r.value) || 0) / max) * 100);
        return (
          <li key={`${r.label}-${i}`}>
            <div className="flex items-baseline justify-between gap-3">
              <span className="line-clamp-2 min-w-0 text-sm text-slate-800 dark:text-slate-100">{r.label}</span>
              <span className="shrink-0 whitespace-nowrap tabular-nums">
                <span className="text-sm font-semibold text-slate-900 dark:text-slate-50">{formatNumber(r.value)}</span>{" "}
                <span className="text-xs text-slate-500 dark:text-slate-400">{unit}</span>
              </span>
            </div>
            <div className="mt-1.5 flex items-center gap-3">
              <div className="min-w-0 flex-1">
                <div className="h-1.5 rounded-sm bg-primary dark:bg-primary-light" style={{ width: `${pct}%` }} />
              </div>
              {r.meta && <span className="w-16 shrink-0 text-right text-xs tabular-nums text-slate-500 dark:text-slate-400">{r.meta}</span>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
